import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 84916A68-B413-4D71-B4E7-5FD64914B354
 * name resize-bottom-right
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/resize-bottom-right.svg
 * tags
 */
export const ResizeBottomRightIcon = createSvgIcon(<><path d="M22,22H20V20H22V22M22,18H20V16H22V18M18,22H16V20H18V22M18,18H16V16H18V18M14,22H12V20H14V22M22,14H20V12H22V14Z" /></>, 'ResizeBottomRightIcon');
export default ResizeBottomRightIcon